import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { t } from 'i18next';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import './ExpandTable.css';

interface ExpandTableProps {
  onToggle: (active: boolean) => void;
  active: boolean;
}

const ExpandTable: React.FC<ExpandTableProps> = ({ onToggle, active }) => {
  const handleToggle = () => {
    onToggle(!active);
  };

  return (
    <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', p: '0' }}>
      <Tooltip arrow placement='top' title={<>{t('showEntireTable')}</>}>
        <IconButton className={'REQXXI-Request-TogleTable'} sx={{ color: '#fff' }} color='inherit' onClick={handleToggle}>
          {active
            ? <KeyboardArrowUpIcon/>
            : <KeyboardArrowDownIcon/>
          }
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default ExpandTable;
